import { createUseStyles } from "react-jss";
import { breakpoints } from "../../../constants/breakpoints";
import { colors } from "../../../constants/colors";

const styles = createUseStyles({
  modalContent: {
    margin: "22px 0 0 0"
  },
  footerBtns: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
    fontSize: "16px",
    fontWeight: "600",
    lineHeight: "24px",
    alignItems: "center"
  },
  checkbox: {
    marginRight: "12px",
    cursor: "pointer"
  },
  modal: {
    width: "400px",
    "& .modal-header": {
      padding: "24px 24px 20px 24px",
      display: "flex",
      justifyContent: "center",
      "& div": {
        height: "48px",
        border: "none",
        boxShadow: "none",
        padding: "12px",
        borderRadius: "24px",
        backgroundColor: colors.pinkRed,
        margin: "0 auto",
        "& svg": {
          display: "flex",
          height: "48px",
          width: "48px"
        },
      },
      "& button": {
        fontSize: "14px",
        position: "absolute",
        top: "32px",
        right: "32px"
      }
    },
    "& .modal-title": {
      padding: "0 24px",
      wordBreak: "break-word",
      textAlign: "center",
      lineHeight: "28px"
    },
    "& .modal-body": {
      padding: "8px 24px",
      fontSize: "14px",
      fontWeight: "400",
      lineHeight: "20px",
      wordBreak: "break-word",
      textAlign: "center"
    },
    "& .modal-footer": {
      padding: "24px 24px"
    },
    "& .modal-footer>*": {
      margin: "0px"
    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      width: "auto"
    }
  },
  cancelBtn: {
    extend: "footerBtns",
    height: "100%",
    alignItems: "center",
    height: "44px"
  },
  cancelBtnCol: {
    paddingRight: "6px",
    [`@media (max-width: ${breakpoints.xs}px)`]: {
      paddingLeft: "10px",
      paddingRight: "2px"
    }
  },
  saveBtn: {
    extend: "footerBtns",
    height: "44px",
    whiteSpace: "nowrap"
  },
  customDisabled: {
    pointerEvents: "none",
    backgroundColor: `${colors.disabledRed} !important`,
    border: `1px solid ${colors.disabledRed} !important`
  },
  saveBtnCol: {
    paddingLeft: "6px",
    [`@media (max-width: ${breakpoints.xs}px)`]: {
      paddingLeft: "4px",
      paddingRight: "10px"
    }
  }
});

export default styles;
